import { post, get, baseURL } from "@/utils/request";

// i18n API
export const getHomeConfig = () => post(`/homeConfig/homeConfig`);

export const getCustomerServiceList= () => post(`/customerService/getCustomerServiceList`);


//Home config
export const getHomePageData = () => get(`/common/getHomePageData`);

export const backendRechargeClaim = (data: any) => post(`/activity/backendRechargeClaim`, data);

// Get face book tracking pixel Id
export const getPixelId = (data: any) => post(`/promotionChannel/getPid`, data);

// Get face book tracking event
export const updateFacebookStats = (data: any) => post(`/promotionChannel/updateStats`, data);